export default {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true},
 clients: {"default": {"httpEndpoint": "https://ei47jz5ivnavte5kxhyrvf2bk4.appsync-api.ap-northeast-1.amazonaws.com/graphql", "defaultOptions": {"query": {"fetchPolicy": "no-cache"}, "watchQuery": {"fetchPolicy": "no-cache"}}, "authType": "Bearer", "authHeader": "Authorization", "tokenName": "apollo:default.token", "tokenStorage": "cookie"}}
}